import { AfterViewInit, Component, OnInit } from '@angular/core';
import { BaseChart } from '../../question.service';
declare var L: any;

@Component({
  selector: 'app-map-chart',
  templateUrl: './map-chart.component.html',
  styleUrl: './map-chart.component.css'
})
export class MapChartComponent extends BaseChart implements OnInit, AfterViewInit {
  private map: any;
  rendered: boolean = false;
  hidden: boolean = true;
  static nextId = 0;
  id = "mapquest-geo-chart";

  constructor() {
    super();
    if (L.mapquest.key == "") {
      L.mapquest.key = '0yrFZX5l3t7vwej1RvFtmQVRIgQYlgct';
    }
  }

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
  }

  renderData(): boolean {
    if (this.rendered) {
      return false;
    }

    if (this.data.length == 0) {
      this.rendered = true;
      return true;
    }

    let coords = this.getCoordinates(this.data[0].Response);
    if (coords[0] == 0) {
      return true;
    }

    if (this.map != null) {
      return true;
    }

    this.map = L.mapquest.map(this.id, {
      center: [coords[0], coords[1]],
      layers: L.mapquest.tileLayer('map'),
      zoom: 7
    });
    for (let i = 0; i < this.data.length; i++) {
      this.addToMap(this.data[i].Response);
    }

    this.rendered = true;
    return false;
  }

  getCoordinates(coordinates: string): number[] {
    let c = coordinates.split(',');
    let coords: number[] = [];
    coords.push(Number(c[0]));
    coords.push(Number(c[1]));
    return coords;
  }

  addToMap(coordinates: string) {
    let coords = this.getCoordinates(coordinates);
    L.marker(coords, {
      icon: L.mapquest.icons.marker(),
      draggable: false
    }).bindPopup('You are here!').addTo(this.map);
    this.map.addControl(L.mapquest.control());
  }
}
